import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import SectionAppTitle from "./SectionAppTitle";
import { Link } from "react-router-dom";
import useMediaQuery from "app/hooks/useMediaQuery";
import { remAccents } from "@helpers/utils";
import { isNull, isUndefined, isEmpty } from "lodash";
import "./AppMenu.css";

SectionAhorro.propTypes = {
  title: PropTypes.string,
  setShow: PropTypes.func,
  closeLeft: PropTypes.func,
  sectionIcon: PropTypes.string,
};

function SectionAhorro({
  title,
  setShow = () => {},
  closeLeft = () => {},
  sectionIcon = "",
  ...props
}) {
  const isMobile = useMediaQuery("(max-width: 1279px)");

  const [sectionCols, setSectionCols] = useState([]);

  //Selectores del Estado
  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { mainMenuSections } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { aCCreditosPersonales } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito?.creditosPersonales
  );
  const { aCCreditosHipotecarios } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito?.creditosHipotecarios
  );
  const { aCCreditosProductivos } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito?.creditosProductivos
  );
  const { aCAhorroProgramado } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito?.ahorrosProgramados
  );
  const { aCInversion } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito?.inversiones
  );
  const { planesAsistencia } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito
  );
  const { tarjetasCredito } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito
  );
  const { bienesBanner } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito
  );
  const { serviahorro } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito
  );

  const DATA_INVENTORY = {
    aCCreditosPersonales: aCCreditosPersonales,
    aCCreditosHipotecarios: aCCreditosHipotecarios,
    aCCreditosProductivos: aCCreditosProductivos,
    aCAhorroProgramado: aCAhorroProgramado,
    aCInversion: aCInversion,
    planesAsistencia: planesAsistencia,
    tarjetasCredito: tarjetasCredito,
    bienesBanner: bienesBanner,
    serviahorro: serviahorro,
  };

  useEffect(() => {
    let columnas = {
      columna1: [],
      columna2: [],
      columna3: [],
      columna4: [],
      columna5: [],
    };
    let claves = Object.keys(columnas);
    let setCols = [];

    for (let i = 0; i < claves.length; i++) {
      let clave = claves[i];
      let index = i + 1;

      mainMenuSections.forEach((sec) => {
        sec.columna === index && columnas[clave].push(sec);
      });

      columnas[clave].sort(function (a, b) {
        return a.fila - b.fila;
      });
      setCols.push(columnas[clave]);
    }
    setSectionCols(setCols);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const simpleSubMenuBuilder = (
    selector,
    mainUriName,
    title,
    conListado = true
  ) => {
    const curStartSection =
      rutas && rutas?.filter((uri) => uri?.name === mainUriName);
    const rootUri =
      !isEmpty(curStartSection) && curStartSection[0]?.url.includes("/:id")
        ? curStartSection[0]?.url.replace("/:id", "")
        : curStartSection[0]?.url;
    const options =
      !isUndefined(selector) &&
      selector?.map((item) => {
        let newUri = "";
        newUri = !isUndefined(item?.ruta)
          ? item?.ruta.contentItems[0].url.toLowerCase()
          : !isUndefined(item?.idCredito)
          ? item?.idCredito
          : !isUndefined(item?.idCreditoProductivo)
          ? item?.idCreditoProductivo
          : !isUndefined(item?.idAhorro)
          ? item?.idAhorro
          : !isUndefined(item?.idInversion)
          ? item?.idInversion
          : !isUndefined(item?.titulo)
          ? remAccents((item?.titulo).replace(/ /gi, "-").toLowerCase())
          : "#";

        newUri = newUri.includes("/") ? newUri.replace("/", "") : newUri;
        const items = { title: item?.titulo || item.nombre, url: newUri };
        return items;
      });

    return (
      <>
        <div className="sectionAppSubTitleText" key={title}>
          <Link
            key={title}
            to={!isUndefined(rootUri) ? rootUri : "#"}
            className="sectionAppSubTitleText"
            onClick={() => {
              setShow(false);
              closeLeft();
            }}
          >
            {title}
          </Link>
        </div>
        <ul>
          {options &&
            options.map((option, index) => {
              const uri = option.url.includes("/")
                ? "/" + option.url
                : !isUndefined(rootUri)
                ? rootUri + "/" + option.url
                : option.url;
              return (
                <li
                  key={index}
                  onClick={() => {
                    setShow(false);
                    closeLeft();
                  }}
                >
                  <a
                    key={index}
                    href={uri}
                    className={`nav-link pt-1 pb-1 mb-2 ${
                      isMobile && "text-blue"
                    }`}
                  >
                    {option.title}
                  </a>
                </li>
              );
            })}
        </ul>
      </>
    );
  };

  const getSelector = (nameSelector) => {
    return DATA_INVENTORY[nameSelector];
  };

  const renderSection = (section, index) => {
    if (!isNull(section?.nombreTecnicoTipoContenido)) {
      return simpleSubMenuBuilder(
        getSelector(section?.nombreTecnicoTipoContenido),
        section?.titulo,
        section?.displayText,
        true
      );
    } else {
      return (
        <div key={index}>
          <div key={index} className="sectionAppSubTitleText">
            {section.url ? (
              <Link
                key={index}
                to={section?.url}
                className="sectionAppSubTitleText"
                onClick={() => {
                  setShow(false);
                  closeLeft();
                }}
              >
                {section?.displayText}
              </Link>
            ) : (
              <div key={index} className="sectionAppSubTitleText">
                {section?.displayText}
              </div>
            )}
          </div>

          {!isEmpty(section?.aCOpcionesSeccionPersonalizada.contentItems) && (
            <ul>
              {section?.aCOpcionesSeccionPersonalizada.contentItems.map(
                (opCustom, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        setShow(false);
                        closeLeft();
                      }}
                    >
                      <a
                        key={index}
                        href={opCustom?.url}
                        className={`nav-link pt-1 pb-1 mb-2 ${
                          isMobile && "text-blue"
                        }`}
                      >
                        {opCustom?.titulo}
                      </a>
                    </li>
                  );
                }
              )}
            </ul>
          )}
        </div>
      );
    }
  };

  return (
    <>
      <SectionAppTitle title={title} imgSrc={sectionIcon} />
      <div
        key={title}
        className={`d-flex ${
          isMobile ? "flex-column w290" : "justify-content-between"
        }`}
      >
        {sectionCols.map((col, index) => {
          return (
            <div key={index}>
              <div key={index}>
                {col.map((sec, index) => {
                  return <div key={index}>{renderSection(sec, index)}</div>;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default SectionAhorro;
